export default __webpack_public_path__ + "static/media/ganzkoerper-reward-shape.df56061a.svg";